import { Platform } from 'react-native';
import {
  CardAction,
  TCardActionProps,
} from '@/common/components/CardAction/CardAction';
import { Switch } from '@/common/components/Switch/Switch';

export interface TCardActionToggleProps
  extends Omit<TCardActionProps, 'action'> {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function CardActionToggle({
  checked,
  onChange,
  ...cardProps
}: TCardActionToggleProps) {
  const switchComp = (
    <Switch
      checked={checked}
      variant="simple"
      onChange={onChange}
      disabled={cardProps.disabled}
    />
  );

  return (
    <CardAction
      {...cardProps}
      action={
        Platform.OS === 'web' ? (
          <div onClick={(evt) => evt.stopPropagation()}>{switchComp}</div>
        ) : (
          switchComp
        )
      }
      onPress={() => onChange(!checked)}
    />
  );
}
